import { ProcessPartner, ProcessPartnerType } from "../models/ProcessPartner";
import api from "./api";

export const getProcessPartners = async (
  type?: ProcessPartnerType
): Promise<ProcessPartner[]> => {
  try {
    const response = await api.get(`/api/processPartner`, {
      params: type ? { type } : undefined,
    });
    return response.data ?? [];
  } catch (error) {
    console.log("error", error);
    return [];
  }
};

export const saveProcessPartner = async (data: ProcessPartner) => {
  try {
    const response = await api.post(`/api/processPartner`, data);
    if (!response.data.success) {
      console.log("error", response.data.notifications);
    }
    return response;
  } catch (error) {
    console.log("error", error);
  }
};

export const deleteProcessPartner = async (id: string) => {
  try {
    const response = await api.delete(`/api/processPartner/${id}`);
    return response;
  } catch (error) {
    console.log("error", error);
  }
};
